module.exports = __webpack_public_path__ + "static/download-btn-appstore-fb633e5dafd289b5f346e862ffdd3f8a.png";